// extracted by mini-css-extract-plugin
export default {"container":"HalfText_container__LLLRI","title":"HalfText_title__iPeTy","description":"HalfText_description__fRijZ"};